import { useQuery } from "@tanstack/react-query";
import { fetchAdminOutreach } from "../api/admin";

export function useAdminOutreach() {
  return useQuery({
    queryKey: ["admin", "outreach"],
    queryFn: fetchAdminOutreach,
  });
}
